import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import Navbar from './components/Navbar.tsx';
import Sidebar from './components/Sidebar.tsx';
import Dashboard from './pages/Dashboard.tsx';
import Login from './pages/Login.tsx';
import Sanctions from './pages/Sanctions.tsx';
import Parametres from './pages/Parametres.tsx';
import { useTheme } from './hooks/useTheme.ts';
import './App.css';

const ProtectedRoutes = () => {
  const [authenticated, setAuthenticated] = useState<boolean | null>(null);

  useEffect(() => {
    axios.get<{ csrfToken: string }>('/auth/me')
      .then(({ data }) => {
        axios.defaults.headers.common['X-CSRF-Token'] = data.csrfToken;
        setAuthenticated(true);
      })
      .catch(() => setAuthenticated(false));
  }, []);

  if (authenticated === null) return <div>Chargement...</div>;
  if (!authenticated) return <Navigate to="/login" replace />;

  return (
    <div className="app-container">
      <Navbar />
      <Sidebar />
      <div className="content-wrapper">
        <div className="main-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

const App = () => {
  useTheme();

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route element={<ProtectedRoutes />}>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/sanctions" element={<Sanctions />} />
          <Route path="/parametres" element={<Parametres />} />
        </Route>
      </Routes>
    </Router>
  );
};

export default App;
